import React, { useState } from 'react';

const BankAccountFilter = ({ 
  availableAccounts, 
  selectedAccounts, 
  onSelectionChange,
  label = "Bank Accounts" 
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleAccountToggle = (accountKey) => {
    const newSelection = selectedAccounts.includes(accountKey)
      ? selectedAccounts.filter(key => key !== accountKey)
      : [...selectedAccounts, accountKey];
    
    onSelectionChange(newSelection);
  };

  const handleSelectAll = () => {
    onSelectionChange(availableAccounts.map(acc => acc.key));
  };

  const handleClearAll = () => {
    onSelectionChange([]);
  };

  const selectedCount = selectedAccounts.length;
  const totalCount = availableAccounts.length;

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      
      {/* Trigger Button */}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="input-field text-left flex items-center justify-between w-full"
      >
        <span className="text-sm">
          {selectedCount === 0 
            ? 'Select accounts...' 
            : selectedCount === totalCount 
              ? 'All accounts selected'
              : `${selectedCount} of ${totalCount} selected`
          }
        </span>
        <svg 
          className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Dropdown */}
      {isOpen && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg animate-fade-in">
          {/* Header with actions */}
          <div className="p-3 border-b border-gray-200 bg-gray-50 rounded-t-lg">
            <div className="flex justify-between items-center">
              <span className="text-sm font-medium text-gray-700">Select Accounts</span>
              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={handleSelectAll}
                  className="px-2 py-1 text-xs font-medium text-primary-700 bg-primary-50 border border-primary-200 rounded hover:bg-primary-100 transition-colors duration-200"
                >
                  All
                </button>
                <button
                  type="button"
                  onClick={handleClearAll}
                  className="px-2 py-1 text-xs font-medium text-gray-600 bg-gray-50 border border-gray-200 rounded hover:bg-gray-100 transition-colors duration-200"
                >
                  None
                </button>
              </div>
            </div>
          </div>

          {/* Account List */}
          <div className="max-h-64 overflow-y-auto">
            {availableAccounts.length === 0 ? (
              <div className="p-3 text-sm text-gray-500 text-center">
                No accounts available
              </div>
            ) : (
              availableAccounts.map((account) => (
                <label
                  key={account.key}
                  className="flex items-center p-3 hover:bg-gray-50 cursor-pointer transition-colors duration-150"
                >
                  <input
                    type="checkbox"
                    checked={selectedAccounts.includes(account.key)}
                    onChange={() => handleAccountToggle(account.key)}
                    className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded mr-3"
                  />
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-gray-900 truncate">
                      {account.bank}
                    </div>
                    <div className="text-xs text-gray-500 truncate">
                      {account.accountNumber}
                    </div>
                  </div>
                </label>
              ))
            )}
          </div>
        </div>
      )}

      {/* Backdrop to close dropdown */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-40" 
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default BankAccountFilter;